export default __webpack_public_path__ + "static/media/deny.7e43b2e0.svg";